import { OBSIDIAN } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureText = styled.div.withConfig({
  displayName: "ChecklistItemTranslated__FeatureText",
  componentId: "sc-1cyzubt-0"
})(["font-size:", "px;"], ({
  fontSize
}) => fontSize);
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "ChecklistItemTranslated__StyledFlex",
  componentId: "sc-1cyzubt-1"
})(["cursor:", ";"], ({
  hasTooltip
}) => hasTooltip && 'help');
const ChecklistItemTranslated = ({
  tooltipMessage,
  message,
  secondaryMessage,
  className,
  iconName = 'success',
  iconColor = OBSIDIAN,
  fontSize = 14
}) => {
  const hasTooltip = !!tooltipMessage;
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "top",
    title: tooltipMessage,
    children: /*#__PURE__*/_jsxs(StyledFlex, {
      className: className,
      hasTooltip: hasTooltip,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-3",
        color: iconColor,
        name: iconName
      }), /*#__PURE__*/_jsx(FeatureText, {
        fontSize: fontSize,
        children: message
      }), secondaryMessage && /*#__PURE__*/_jsx("span", {
        className: "m-left-1",
        children: /*#__PURE__*/_jsx(FeatureText, {
          fontSize: fontSize,
          children: secondaryMessage
        })
      })]
    })
  });
};
export default ChecklistItemTranslated;